const publicProfilePattern = /^\/p\/[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const inquiryReturnPattern = /^\/p\/([0-9a-f-]{36})\?inquiry=([0-9a-f-]{36})$/i;

export function isPublicProfilePath(path) {
  return publicProfilePattern.test(path);
}

export function getSafeInquiryReturnTo(value) {
  if (typeof value !== 'string') return '';
  const match = inquiryReturnPattern.exec(value);
  if (!match || !publicProfilePattern.test(`/p/${match[1]}`) || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(match[2])) return '';
  return `/p/${match[1]}?inquiry=${match[2]}`;
}

export function resolveAppRoute(path, sessionReady, hasSession, recovery = false) {
  if (!sessionReady) return 'loading';
  if (recovery) return 'recovery';
  if (isPublicProfilePath(path)) return 'public-profile';
  if (path === '/app') return hasSession ? 'app' : 'guard';
  if (path === '/auth') return hasSession ? 'redirect' : 'auth';
  if (path === '/') return 'landing';
  return 'not-found';
}
